import Component from './MonitoredDocumentBrowser.component.jsx';
import { connect } from 'react-redux';
import { fetchMonitoredDocument } from '../state/actions/MonitoredDocumentActions';
import fromState from '../state/selectors';

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
    return {
        fetching: fromState.MonitoredDocument.isFetching(state),
        fetched: fromState.MonitoredDocument.isFetched(state),
        failed: fromState.MonitoredDocument.hasFailed(state),
        monitoredDocument: fromState.MonitoredDocument.getMonitoredDocument(state),
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        fetchMonitoredDocument: () => dispatch(fetchMonitoredDocument(ownProps.documentId)),
    };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    return {
        ...ownProps,
        ...stateProps,
        onInitialLoad: dispatchProps.fetchMonitoredDocument,
    };
};

// EXPORT CONTAINER
export default connect(mapStateToProps, mapDispatchToProps, mergeProps, { forwardRef: true })(
    Component
);
